/* Google Ads conversion tracking – Basic Consent Mode v2.
   gtag.js is never loaded and nothing is sent to Google without marketing consent. */
const ID = process.env.REACT_APP_GADS_ID || "";
const LABEL = process.env.REACT_APP_GADS_LABEL || "";
const SENT_KEY = "rbtun_gads_sent";

export const gadsConfigured = () => /^AW-\d+$/.test(ID) && LABEL.length > 0;
export const gadsLoaded = () => !!window.__rbtunGadsLoaded;

/* Ad click IDs from the landing URL, kept in memory only (never stored before consent), so they are
   not lost if the visitor navigates within the site (e.g. "Les mer") before clicking "Godta alle". */
const CLICK_KEYS = ["gclid", "gbraid", "wbraid", "gclsrc", "dclid"];
const landingClickIds = (() => {
  const q = new URLSearchParams(window.location.search);
  return CLICK_KEYS.filter((k) => q.get(k)).map((k) => [k, q.get(k)]);
})();

const restoreClickIds = () => {
  const url = new URL(window.location.href);
  if (!landingClickIds.length || CLICK_KEYS.some((k) => url.searchParams.has(k))) return;
  landingClickIds.forEach(([k, v]) => url.searchParams.set(k, v));
  window.history.replaceState(window.history.state, "", url.pathname + url.search + url.hash);
  debug("click ids restored", landingClickIds.map(([k]) => k));
};

const debug = (...a) => {
  if (new URLSearchParams(window.location.search).has("gads_debug") || localStorage.getItem("rbtun_gads_debug") === "1") {
    console.info("[gads]", ...a);
  }
};

export const loadGads = (statistics) => {
  if (!gadsConfigured()) return debug("not configured – skipped");
  if (gadsLoaded()) return;
  restoreClickIds();
  window.dataLayer = window.dataLayer || [];
  window.gtag = function gtag() { window.dataLayer.push(arguments); };
  window.gtag("consent", "default", { ad_storage: "denied", ad_user_data: "denied", ad_personalization: "denied", analytics_storage: "denied" });
  window.gtag("consent", "update", {
    ad_storage: "granted", ad_user_data: "granted", ad_personalization: "granted",
    analytics_storage: statistics ? "granted" : "denied",
  });
  window.gtag("js", new Date());
  window.gtag("config", ID);
  const s = document.createElement("script");
  s.async = true;
  s.src = `https://www.googletagmanager.com/gtag/js?id=${ID}`;
  document.head.appendChild(s);
  window.__rbtunGadsLoaded = true;
  debug("loaded", ID);
};

export const clearGadsCookies = () => {
  const parts = window.location.hostname.split(".");
  const domains = parts.map((_, i) => parts.slice(i).join(".")).filter((d) => d.includes("."));
  document.cookie.split(";").map((c) => c.split("=")[0].trim()).filter((n) => n.startsWith("_gcl_")).forEach((n) => {
    document.cookie = `${n}=; Max-Age=0; path=/`;
    domains.forEach((d) => { document.cookie = `${n}=; Max-Age=0; path=/; domain=.${d}`; });
  });
};

const sentIds = () => {
  try {
    const v = JSON.parse(localStorage.getItem(SENT_KEY) || "[]");
    return Array.isArray(v) ? v : [];
  } catch {
    return [];
  }
};

/* Call ONLY after the server has accepted the inquiry. inquiryId = id returned by the API. */
export const trackLead = (inquiryId, hasMarketingConsent) => {
  if (!inquiryId || !hasMarketingConsent || !gadsConfigured() || !gadsLoaded()) return debug("conversion skipped", { inquiryId, hasMarketingConsent });
  const ids = sentIds();
  if (ids.includes(inquiryId)) return debug("duplicate skipped", inquiryId);
  localStorage.setItem(SENT_KEY, JSON.stringify([...ids, inquiryId].slice(-20)));
  window.gtag("event", "conversion", { send_to: `${ID}/${LABEL}`, transaction_id: inquiryId });
  debug("conversion sent", { send_to: `${ID}/${LABEL}`, transaction_id: inquiryId });
};
